import { Paper, styled } from '@mui/material';

const GridItem = styled(Paper, { shouldForwardProp: prop => prop !== 'clickable' })(({ theme, clickable }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  paddingBottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  height: '100%',
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  transition: 'transform 120ms ease, box-shadow 120ms ease',
  ...(clickable
    ? {
        'cursor': 'pointer',
        '&:hover': {
          boxShadow: theme.shadows[4],
          transform: 'translateY(-2px)',
        },
      }
    : {}),
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export default GridItem;
